<template>
  <div class="ticket-pipeline">
    <z-steps direction="vertical">
      <z-step
        v-for="(item, index) in info"
        :key="index"
        :title="item.title"
        :time="item.time"
        :description="item.description"
      >
        <div v-if="item.imgs && item.imgs.length" slot="description">
          <div>{{ item.description }}</div>
          <div class="image-wrap">
            <img-item v-for="(obj, index) in item.imgs" :picUrl="obj" :key="index"></img-item>
          </div>
        </div>
      </z-step>
    </z-steps>
    <!-- <time-pipeline
            v-for="(item, idx) in vertical"
            :key="idx"
            :info="item"
            :isLast="idx === 0"
        >
            <div slot="time">
                <p>03-11 23:23</p>
            </div>
            <div slot="content">
                <p class="pipe-desc">{{item.description}}</p>
                <div v-if="item.imgs && item.imgs.length">
                    <img-item
                        v-for="(obj, index) in item.imgs"
                        :picUrl="obj"
                        :key="index"
                    ></img-item>
                </div>
            </div>
        </time-pipeline> -->
  </div>
</template>

<script>
import { Step, Steps } from '@zz-common/zz-ui'
import setPicSize from '@zz-app/setPicSize'
import ImgItem from '../../components/img-item/index'
// import TimePipelie from '../../components/time-pipeline/index'
export default {
  name: 'TicketPipeline',
  props: ['info'],
  components: {
    'z-steps': Steps,
    'z-step': Step,
    // 'time-pipeline': TimePipelie,
    'img-item': ImgItem
  },
  data() {
    return {
      vertical: []
    }
  },
  methods: {
    $setPicSize(url) {
      // 后台没有返回地址给个默认的
      if (!url) {
        return setPicSize(
          'https://pic4.zhuanstatic.com/zhuanzh/ba6b90b0-6620-41fb-9b64-eb1f6ce34624.png',
          100,
          100
        )
      }
      // 部分后台返回的图片url非法，不做处理直接返回
      const reg = /\.(png|jpg|jpeg|gif)/i
      return reg.test(url) ? setPicSize(url, 300, 200) : url
    }
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
